import React from 'react';
import { QuickServiceTileSection } from './QuickServiceTileSection';
import { buildOrderedQuickTiles, type CmsTopicSections } from '../utils/resolveQuickSection';

const TILE_ORDER = ['rcic', 'lawyers', 'accountants', 'paralegals'] as const;

const TILE_ICONS: Record<string, string> = {
  rcic: 'ti-certificate',
  lawyers: 'ti-gavel',
  accountants: 'ti-calculator',
  paralegals: 'ti-file-text',
};

export interface ProfessionalHelpQuickSectionProps {
  onSelect: (categoryId: string, slug: string) => void;
  topicSections: CmsTopicSections;
}

export const ProfessionalHelpQuickSection: React.FC<ProfessionalHelpQuickSectionProps> = ({
  onSelect,
  topicSections,
}) => (
  <QuickServiceTileSection
    id="professionals"
    title="Professional help"
    items={buildOrderedQuickTiles('professionals', TILE_ORDER, TILE_ICONS, topicSections, 'ti-user')}
    onSelect={onSelect}
    variant="professional"
    labelInside
  />
);
